import { colors } from '@akin-home/theme';
import { StyleSheet } from 'react-native';

export const button_base_styles = {
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'center',
};

export const button_size_styles = {
  small: {
    borderRadius: 12,
    padding: 9,
  },
  medium: {
    borderRadius: 15,
    padding: 12,
  },
  large: {
    borderRadius: 20,
    padding: 16,
  },
  xlarge: {
    borderRadius: 22,
    padding: 20,
  },
};

export const button_variant_styles = {
  primary: {
    backgroundColor: colors.primary[70],
  },
  secondary: {
    backgroundColor: 'rgba(5, 22, 51, 0.1)',
  },
  white: {
    backgroundColor: 'white',
  },
  text: {
    backgroundColor: 'transparent',
  },
};

export const textSizeStyles = {
  small: `
    font-size: 13px;
  `,
  medium: `
    font-size: 15px;
  `,
  large: `
   font-size: 17px;
  `,
  xlarge: `
    font-size: 22px;
  `,
};

export const textVariantStyles = {
  primary: `
    color: white;
  `,
  secondary: `
    color: #051633;
;
  `,
  text: `
    color: #051633;
  `,
  white: `
    color: #051633;
  `,
};

const _button_styles: any = {};

/** Optimising button styles, since they are used everywhere */
Object.keys(button_size_styles).forEach((size) => {
  Object.keys(button_variant_styles).forEach((variant) => {
    const styleName = `${size}_${variant}_button`;

    _button_styles[styleName] = {
      ...button_base_styles,
      ...button_size_styles[size],
      ...button_variant_styles[variant],
    };
  });
});

export const button_styles = StyleSheet.create(_button_styles);
